import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

// The form keeps whole warehouse rows so the table can render them; the payload keeps only their
// order, expressed as a list of ids.
export function buildWarehousePriorityPatchBody(
  warehousesPriority: WarehouseDirectSaleVariantsDetailFormSchemaType['warehousesPriority']
) {
  return {
    warehouseIds: warehousesPriority.map((warehousePriority) => warehousePriority.warehouseId),
  };
}
